(function () {
  // Wait for fbq to be available (initialized in meta-pixel.liquid)
  if (typeof fbq === 'undefined') return;

  var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CAD';

  // ViewContent on product pages
  var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
  if (meta && meta.product) {
    var p = meta.product;
    var variant = p.variants && p.variants[0];
    fbq('track', 'ViewContent', {
      content_ids: [String(p.id)],
      content_type: 'product',
      content_name: p.title,
      currency: currency,
      value: variant ? (variant.price / 100) : 0
    });
  }

  // AddToCart via fetch intercept (Horizon uses fetch for cart operations)
  var _fetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    if (url.includes('/cart/add')) {
      return _fetch.apply(this, arguments).then(function (resp) {
        resp.clone().json().then(function (data) {
          if (data && data.id) {
            fbq('track', 'AddToCart', {
              content_ids: [String(data.id)],
              content_type: 'product',
              content_name: data.title || '',
              currency: currency,
              value: (data.price || 0) / 100
            });
          }
        }).catch(function () {});
        return resp;
      });
    }
    return _fetch.apply(this, arguments);
  };

  // InitiateCheckout — checkout button name="checkout" or links to /checkout
  document.addEventListener('click', function (e) {
    var el = e.target;
    if (!el) return;
    var isCheckoutBtn = el.matches('[name="checkout"]') || !!el.closest('[name="checkout"]');
    var isCheckoutLink = !!el.closest('a[href*="/checkout"]');
    if (isCheckoutBtn || isCheckoutLink) {
      fbq('track', 'InitiateCheckout');
    }
  }, true);

})();